import Joi from 'joi';
import { guestInfoValuesList, contactInfoValuesList } from '../../constants';
import { ccToPcConverter } from 'helpers/commonUtils';

let guestInsightsFieldList = {};
guestInfoValuesList.forEach(guestInfo => {
    guestInsightsFieldList[guestInfo.value] = Joi.string()
        .label(ccToPcConverter(guestInfo.value))
        .max(guestInfo.maxLength)
        .allow('')
        .messages({
            'string.max': `Maximum ${guestInfo.maxLength} characters`
        });
});
contactInfoValuesList.forEach(contactInfo => {
    guestInsightsFieldList[contactInfo.value] = Joi.string()
        .label(ccToPcConverter(contactInfo.value))
        .max(contactInfo.maxLength)
        .allow('')
        .messages({
            'string.max': `Maximum ${contactInfo.maxLength} characters`
        });
});
const guestInsightValidator = Joi.object(guestInsightsFieldList);

export default guestInsightValidator;